import httpData from "./httpData";

/**
 * Resolves relative media URLs to absolute URLs by prepending the API base URL
 * @param url - The URL that may be relative or absolute
 * @returns The absolute URL
 */
export const resolveMediaUrl = (url: string | undefined): string | undefined => {
	if (!url) return undefined;

	// If already absolute URL, return as-is
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}

	// If relative, prepend API base URL
	const baseUrl = httpData.url || "";
	// Ensure no double slashes
	const separator = url.startsWith("/") ? "" : "/";
	return `${baseUrl}${separator}${url}`;
};

/**
 * Resolves multiple media URLs
 */
export const resolveMediaUrls = (urls: {
	videoUrl?: string;
	posterUrl?: string;
	previewUrl?: string;
}) => ({
	videoUrl: resolveMediaUrl(urls.videoUrl),
	posterUrl: resolveMediaUrl(urls.posterUrl),
	previewUrl: resolveMediaUrl(urls.previewUrl),
});
